import { Container, Row, Col } from "react-bootstrap";
import {
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaEnvelope,
  FaGlobe,
} from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../assets/logo.png";

export default function Footer() {
  const year = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const isHome = location.pathname === "/";

  const handleAboutClick = () => {
    if (!isHome) {
      navigate("");
    }
    setTimeout(
      () => {
        document
          .getElementById("about-us")
          ?.scrollIntoView({ behavior: "smooth" });
      },
      isHome ? 0 : 100
    );
  };

  const handleContactClick = () => {
    if (!isHome) {
      navigate("");
    }
    setTimeout(
      () => {
        document
          .getElementById("contact-us")
          ?.scrollIntoView({ behavior: "smooth" });
      },
      isHome ? 0 : 100
    );
  };

  return (
    <footer className="site-footer">
      <Container>
        <Row className="gy-4">
          <Col md={3}>
            <img
              src={Logo}
              alt="RR Shipping & Logistics"
              className="footer-logo"
            />
            <h5 className="footer-title">RR Shipping & Logistics</h5>
            <p className="footer-text">Your Global Movement Partner</p>
          </Col>

          <Col md={3}>
            <h6 className="footer-title">Quick Links</h6>
            <ul className="footer-links">
              <li>
                <a href="/">Home</a>
              </li>
              <li onClick={handleAboutClick}>About Us</li>
              <li onClick={handleContactClick}>Contact</li>
            </ul>
          </Col>

          <Col md={3}>
            <h6 className="footer-title">Our Services</h6>
            <ul className="footer-links">
              <li onClick={() => navigate("/services/custom-clearance")}>
                Customs Clearance
              </li>
              <li onClick={() => navigate("/services/transportation")}>
                Transportation
              </li>
              <li onClick={() => navigate("/services/freight-forwarding")}>
                Freight Forwarding
              </li>
            </ul>
          </Col>

          <Col md={3}>
            <h6 className="footer-title">Contact</h6>
            <p className="footer-contact">
              <FaPhoneAlt /> +91 63573 10056
            </p>
            <p className="footer-contact">
              <FaPhoneAlt /> +91 70434 44944
            </p>
            <p className="footer-contact">
              <FaEnvelope /> rrshiplog.imp@gmail.com
            </p>
            <p className="footer-contact">
              <FaMapMarkerAlt />
              Office No. B-145, NU-4, Sapna Nagar, Gandhidham, Kutch – 370201,
              Gujarat
            </p>
            <p className="footer-contact">
              <FaGlobe /> www.rrshiplogimp.com
            </p>
          </Col>
        </Row>

        <div className="footer-bottom">
          <p>© {year} RR Shipping & Logistics. All rights reserved.</p>
        </div>
      </Container>
    </footer>
  );
}
